import { usePayloadStore } from '../../stores/payload-store';
import { useJobDataStore } from '../../stores/job-store';

export default async function fetchCustomFields() {
    const payload = usePayloadStore();
    const jobData = useJobDataStore();

    if (payload.exists && jobData.shouldFetchCustomFields) {
        await jobData.fetchCustomFields(payload.jobId);
    }
}
